module.exports = __webpack_public_path__ + "static/media/logo_lancamentos.a10e4ee0.png";